export const determineCorrectServerUrl = () => {
  if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
    return process.env.REACT_APP_PRODUCTION_URL;
  } else {
    return process.env.REACT_APP_LOCAL_URL;
  }
};
